export const tr = {
    all_day: '24 saat',
    friday: 'Cu',
    monday: 'Pt',
    saturday: 'Ct',
    sunday: 'Pa',
    thursday: 'Pe',
    tuesday: 'Sa',
    wednesday: 'Ça',
    weekends: 'hafta sonu',
    working_days: 'hafta içi'
};
